// extracted by mini-css-extract-plugin
module.exports = {"about":"AboutMenuStyle_about__15B9K","item":"AboutMenuStyle_item__3lvqW"};